// source: type/platform.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.type.Platform', null, global);
/**
 * @enum {number}
 */
proto.type.Platform = {
  UNSPECIFIED: 0,
  ANDROID: 1,
  IOS: 2
};

goog.object.extend(exports, proto.type);
